export function getProfileUrl(id) {
    return `/profiles/${id}`;
}
